import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>What We Are Capable of</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
                <br /> Lorem Ipsum has been the industry's standard dummy text.
              </p>
              <h3>Technical Skills</h3>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={meter1} alt="Customized ERP" />
                  <h5>Angular</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="React" />
                  <h5>React</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Web Development" />
                  <h5>Flutter</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Cloud Services" />
                  <h5>Jetpack Compose</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Cloud Services" />
                  <h5>Google Cloud</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Cloud Services" />
                  <h5>AWS</h5>
                </div>
              </Carousel>

              <h3 class="mt-20">Our Services</h3>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={meter1} alt="App Development" />
                  <h5>App Development</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Logo Design" />
                  <h5>Customised ERP</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Automation Tools" />
                  <h5>Customised RAG</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img
        className="background-image-left"
        src={colorSharp}
        alt="Decorative background"
      />
    </section>
  );
};
